export default __webpack_public_path__ + "static/home-cloud-pos-a8fae7530e9757712350a123cd729845.svg";